// @ts-nocheck
import * as selectors from './boxSlideShowSelectors';

export { selectors };
